let Questions = require('./Questions.js');
let Quote = require('./Quote.js');
module.exports = {
    getSteps: function() {
        let steps = Questions.getSteps();
        let returnArray = [];
        steps.map(function(step) {
            returnArray.push(step.name);
        }, this);

        return returnArray;
    },
    getStepQuestions: function(wantedStep) {
        let steps = Questions.getSteps();
        let returnStep = null;
        steps.map(function(step, index) {
            if (wantedStep == index) {
                returnStep = step.questions;
            }
        }, this);

        return returnStep;
    },

    /**
     * sets the current step for the QuestionsScreen to load (when it's rendered)
     * based on the 0-based array of steps
     * @param {int} 0-based index of the step we want to be active
     *     when QuestionsScreen is next rendered
     */
    setCurrentStep(stepIndex) {
        stepIndex = parseInt(stepIndex);
        window.localStorage.setItem('current_step', stepIndex);
    },

    /**
     * returns the total number of variable steps for the current permutation
     * from a 1-based index viewpoint
     * @return {int} the total length of steps
     */
    totalNumberOfSteps: function() {
        let steps = Questions.getSteps();
        return steps.length;
    },
    canMoveToStep: function(stepRequested) {
        stepRequested = parseInt(stepRequested)+1;
        // We can always move to the first Question step so always return true
        if (stepRequested == 0) {
            return true;
        }

        let can = true;
        let steps = Questions.getSteps();
        steps.map(function(step, index) {
            if (index+1 < stepRequested) {
                if (!this.testStepComplete(step.questions)) {
                    can = false;
                }
            }
        }, this);
        return can;
    },
    testStepComplete: function(questions) {
        let somethingFailed = false;
        $.each(questions, function(k, v) {
            if (v.parent === false) {
                if (!Quote.hasAnswers(v.field_name)) {
                    somethingFailed = true;
                }
            }
        });
        return (somethingFailed) ? false : true;
    },
    evaluateSteps: function() {

        let steps = Questions.getSteps();
        let headerArray = [];
        let questionsArray = [];
        let haveInvalidStep = false; // We want a number so we can store the step to show
        let adjustedCurrentStepNumber = 0;
        let adjustedCurrentStepName = "";
        let adjustedCurrentStepTitle = "";

        steps.map(function(step, index) {
            // Save step title for use in header steps
            headerArray.push(step.title);

            // Check to see if this step is complete answer wise
            if (haveInvalidStep === false && !this.testStepComplete(step.questions)) {

                haveInvalidStep = true;
                adjustedCurrentStepNumber = parseInt(index)+1; // set the adjusted (arrays start at 0)step number
                adjustedCurrentStepName = step.name;
                adjustedCurrentStepTitle = step.title;

                // build the questions array to push to state.currentStepQuestions
                $.each(step.questions, function(k, v) {
                    if (v.parent === false) {
                        questionsArray.push(v);
                    }
                });
            }

            // Everything is complete so build final screen questions
            if (haveInvalidStep === false && index === parseInt(steps.length)-1) {
                adjustedCurrentStepName = step.name;
                adjustedCurrentStepTitle = step.title;
                adjustedCurrentStepNumber = steps.length+1;
                $.each(step.questions, function(k, v) {
                    if (v.parent === false) {
                        questionsArray.push(v);
                    }
                });
            }

        }, this);


        // persist the state
        this.setState({
            stepHeaders: headerArray,
            currentStepQuestions: questionsArray,
            currentStepNumber: adjustedCurrentStepNumber,
            currentStepName: adjustedCurrentStepName,
            currentStepTitle: adjustedCurrentStepTitle,
            totalNumberOfSteps: steps.length
        });

        return {
            stepHeaders: headerArray,
            currentStepQuestions: questionsArray,
            currentStepNumber: adjustedCurrentStepNumber,
            currentStepName: adjustedCurrentStepName,
            currentStepTitle: adjustedCurrentStepTitle,
            totalNumberOfSteps: steps.length
        };
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Steps.js
 **/